module.exports = __webpack_public_path__ + "media/assets/images/blog/customer_service_omnichannel-small-833f6a4f8871325814c53a03001e15e9.png";